module.exports = __webpack_public_path__ + "static/media/LEIE.7eb79a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/LEIE.jpg
// module id = 1762
// module chunks = 1